import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FooterItem } from 'src/app/angular-core/components/navigation/footer-base/footer-base.component';
import { IconStatus } from 'src/app/angular-core/interfaces/list-item.interfaces';
import { MessageDialogComponent, MessageBoxCustomButton } from 'src/app/angular-core/components/message-dialog/message-dialog.component'
import { TranslateService } from '@ngx-translate/core';
import { FooterItemsService } from 'src/app/services/footer-items.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AuthService } from 'src/app/angular-core/services/auth.service';
import { IRemoteXPACPortalState } from 'src/app/utils/interfaces/store.interfaces';
import { Store } from '@ngrx/store';
import { selectUserData } from 'src/app/store/selectors/auth.selectors';
import { take } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IApiPermissions } from 'src/app/utils/interfaces/auth.interfaces';
import { PermissionsService } from 'src/app/services/permissions.service';

@UntilDestroy()
@Component({
  selector: 'app-more',
  templateUrl: './more.component.html',
  styleUrls: ['./more.component.scss']
})
export class MoreComponent implements OnInit {

  public footerItems: FooterItem[] = [];
  public isLoading: boolean = true;
  public isXpact: boolean = (<any>window).xpact;
  public isStoppingImpersonation: boolean = false;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private store: Store<IRemoteXPACPortalState>,
    private footerItemsService: FooterItemsService,
    private cdr: ChangeDetectorRef,
    private permissionsService: PermissionsService,
  ) { }

  public ngOnInit(): void {
    this.setFooterItems();
  }

  public getIconStatus(icon: string): IconStatus[]{
    let icons: IconStatus[] = [];
    icons.push({ icon: icon, class: "" });

    return icons;
  }

  public navigate(route: string) {
    this.router.navigate([route]);
  }

  public onBackToLocalClick(): void {
    console.assert(this.isXpact);

    if (this.isStoppingImpersonation) {
      return;
    }

    if (this.stopImpersonatingDialog()) {
      // The exit impersonation dialog was shown instead
      return;
    }

    // url for the XPACT when using local
    const url: URL = new URL((<any>window).xpact);

    // navigate inside the current window back to XPACT(inside XPAC tooling)
    window.location.href = url.href;
  }

  public onLogoutClick(): void {
    console.assert(!this.isXpact);

    if (this.isStoppingImpersonation) {
      return;
    }

    if (this.stopImpersonatingDialog()) {
      // The exit impersonation dialog was shown instead
      return;
    }

    const headerText: string = this.translate.instant("MoreComponent.ConfirmLogout");
    const messageText: string = this.translate.instant("MoreComponent.AreYouSure");

    const dialogRef: MatDialogRef<MessageDialogComponent> = this.dialog.open(MessageDialogComponent, {
      panelClass: 'messagebox-dialog',
      autoFocus: false,
      data: { headerInfo: headerText, message: messageText, buttons: MessageBoxCustomButton.YesNo }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.authService.logout();
      }
    });
  }

  private stopImpersonatingDialog(): boolean {
    let isImpersonating: boolean;
    this.store.select(selectUserData).pipe(take(1)).subscribe(u => isImpersonating = !!u.impersonator);

    if (!isImpersonating) {
      return false;
    }

    const headerText: string = this.translate.instant("MoreComponent.ConfirmStopImpersonating");
    const messageText: string = this.translate.instant("MoreComponent.AreYouSureStopImpersonating");

    const dialogRef: MatDialogRef<MessageDialogComponent> = this.dialog.open(MessageDialogComponent, {
      panelClass: 'messagebox-dialog',
      autoFocus: false,
      data: { headerInfo: headerText, message: messageText, buttons: MessageBoxCustomButton.YesNo }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.authService.logout();
        window.location.href = `${environment.issuer}/Impersonate/Stop?returnUrl=${encodeURIComponent(window.location.href)}`;
      }
    });

    return true;
  }

  private async setFooterItems(): Promise<void> {
    const permissions:IApiPermissions = await this.permissionsService.getPermissions();
    const footerItems: FooterItem[] = this.footerItemsService.getFooterItemsMore(permissions);
    this.footerItems = footerItems;
    this.isLoading = false;
    this.cdr.markForCheck();
  }
}
